import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import capitalize from 'lodash/capitalize'
import propTypes from 'prop-types'

import MonthYearPicker from '@components/MonthPicker/MonthYearPicker'
import FilterGroup from '@components/FilterGroup'
import { StatusFilter } from '@components/StatusFilter'
import Checkbox from '@components/Checkbox'
import Spinner from '@components/spinner'
import { formatNumber } from '@atheneum/api/dist/lib'

const MetricRow = ({ metric, type, openItem }) => (
  <tr>
    <td>
      <div className='row--link' onClick={() => openItem(metric, type)}>
        {metric.name}
      </div>
    </td>
    <td className='right-text'>{metric.totalProjects}</td>
    <td className='right-text'>
      {metric.projectsWithoutRevenue} ({(metric.projectsShare * 100).toFixed(0)}
      %)
    </td>
    <td className='right-text'>{metric.expertsRequired}</td>
    <td className='right-text'>{metric.expertsDelivered}</td>
    <td className='right-text'>{metric.expertsInterviewed}</td>
    <td className='right-text'>{metric.convIVDV}</td>
    <td className='right-text'>{metric.convIVREQ}</td>
    <td className='right-text'>{formatNumber(metric.totalRevenue / 1e6)}</td>
  </tr>
)
MetricRow.propTypes = {
  metric: propTypes.object.isRequired,
  type: propTypes.string.isRequired,
  openItem: propTypes.func.isRequired
}

const MetricTable = ({ metrics, type, openItem }) => {
  return (
    <table className='table-wrapper'>
      <thead>
        <tr>
          <th>{capitalize(type) + ' name'}</th>
          <th className='right-text'>Launched</th>
          <th className='right-text'>No Interviews</th>
          <th className='right-text'>Requested</th>
          <th className='right-text'>Delivered</th>
          <th className='right-text'>Interviewed</th>
          <th className='right-text'>Int/Del</th>
          <th className='right-text'>Int/Req</th>
          <th className='right-text'>Revenue (EUR)</th>
        </tr>
      </thead>
      <tbody>
        {metrics.map(metric => (
          <MetricRow
            key={metric.name}
            metric={metric}
            type={type}
            openItem={openItem}
          />
        ))}
      </tbody>
    </table>
  )
}

MetricTable.propTypes = {
  metrics: propTypes.array,
  openItem: propTypes.func.isRequired,
  type: propTypes.string
}

function FilterOptions ({ type, month, allTime, setVal }) {
  return (
    <div className='project-search-bar'>
      <div className='flex-center'>
        <Checkbox label='All time' onChange={val => setVal('allTime', val)} />
      </div>
      <FilterGroup inView label='Month' labelClass='code-label'>
        <MonthYearPicker
          monthAndYear={month}
          disabled={allTime}
          value={allTime}
          onChange={val => setVal('month', val)}
        />
      </FilterGroup>
      <FilterGroup inView label='Group by' labelClass='code-label'>
        <StatusFilter
          single
          required
          selectedItems={[type]}
          items={['account', 'office']}
          onChange={item => setVal('type', item[0])}
        />
      </FilterGroup>
    </div>
  )
}
FilterOptions.propTypes = {
  type: propTypes.string.isRequired,
  month: propTypes.object,
  allTime: propTypes.bool,
  setVal: propTypes.func
}

class Metric extends Component {
  static propTypes = {
    parentMetricStore: propTypes.object,
    parentAccount: propTypes.object,
    sidebarStore: propTypes.object
  }
  constructor (props) {
    super(props)
    props.parentMetricStore.init(props.parentAccount.id)
  }

  openItem = (metric, type) => {
    this.props.sidebarStore.openSidebar({
      template: 'client-' + type,
      id: metric[type + 'Id']
    })
  }

  render () {
    const store = this.props.parentMetricStore
    return (
      <div className='views-wrapper'>
        <FilterOptions
          type={store.type}
          month={store.month}
          allTime={store.allTime}
          setVal={store.setVal}
        />
        {store.loading ? (
          <Spinner />
        ) : (
          <MetricTable
            metrics={store.metrics}
            type={store.type}
            openItem={this.openItem}
          />
        )}
      </div>
    )
  }
}

export default inject('parentMetricStore', 'sidebarStore')(observer(Metric))
